export default "__VITE_ASSET__Dm4IE9$k__"